import React from "react"
import CustomTable from "../components/CustomTable";
import { deleteSocialMediaPost, getAllSocialMediaPost } from "../services/ApiServices";
import { DeleteButton } from "../components/masterDataForm/DeleteButton";
import { useDispatch, useSelector } from "react-redux";
import { DeleteConfirmDialog } from "../components/userForm/DeleteUser";
import { toast } from "react-toastify";
import SocailMediaImages from "../components/masterDataForm/SocailMediaImages";
import { ImageButton } from "../components/masterDataForm/ImageButton";


const SocialMediaPost = () => {
    const message = `Are you sure you want to delete this social media post?`;
    const [mediaPostConfirmDailogShow, setMediaPostConfirmDailogShow] = React.useState(false);
    const [mediaPostId, setMediaPostId] = React.useState();
    const [socialPostImage, setSocialPostImage] = React.useState([]);
    const [mediaImageShow, setMediaImageShow] = React.useState(false);
    const dispatch = useDispatch();
    const mediaPostInfo = useSelector(state => state.getAllMediaPosts?.mediaPost)
    React.useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await getAllSocialMediaPost();
                dispatch({ type: 'GET_ALL_MEDIA_POST', payload: res.data.data.posts })
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchUsers();
    }, [dispatch]);

    const deleteMediaPostHandle = async () => {
        try {
            const deleteSocialMediaPostRes = await deleteSocialMediaPost(mediaPostId);

            if(deleteSocialMediaPostRes.status === 200) {
                dispatch({ type: 'DELETE_SOCIAL_MEDIA_POST', payload: deleteSocialMediaPostRes.data?.data})
                toast.success(deleteSocialMediaPostRes.data?.message)
                setMediaPostConfirmDailogShow(false)
                return
            }
        } catch (error) {
            toast.error('Something Wrong')
        }
    };
    
    const colDefs = [
        { field: "userId.firstName", flex: 1.2, headerName: 'First Name' },
        { field: "userId.lastName", flex: 1.2, headerName: 'Last Name' },
        { field: "image", flex: 1.2, filter: false, headerName: 'Media Image', cellRenderer: (val) => <ImageButton images={val.data.image} setShowImageBtn={setMediaImageShow} setImages={setSocialPostImage} />},
        { field: "description", flex: 2.5, headerName: 'Media Descriptions' },
        { field: "likes", flex: 1, headerName: 'Likes' },
        { field: "commentCount", flex: 1, headerName: 'Comments' },
        { field: "createdAt", flex: 1, filter: false, headerName: 'Created Date', valueFormatter: (params) => {
            const date = new Date(params.value);
            if (isNaN(date.getTime())) {
                return "Invalid Date"; 
            }
            return date.toISOString().split('T')[0];
        }},
        { field: '_id', flex: 1, filter: false, headerName: 'Action', cellRenderer: (val) => ( <DeleteButton statusId={val.data._id} setId={setMediaPostId} setShowDeleteConfirmPop={setMediaPostConfirmDailogShow} />) }
    ];

    return(
        <React.Fragment>
            <div className="aside-heading">
                <h3>MEDIA POSTS</h3>
            </div>
            <CustomTable colDefs={colDefs} rowData={mediaPostInfo} />
            <SocailMediaImages name="Social Media Images" showImageDialog={mediaImageShow} socialPostImage={socialPostImage} setShowImageDialog={setMediaImageShow}  />
            <DeleteConfirmDialog formName="Social Media Post" message={message}  handleDelete={deleteMediaPostHandle} showDeleteConfirmPop={mediaPostConfirmDailogShow} setShowDeleteConfirmPop={setMediaPostConfirmDailogShow}/>
        </React.Fragment>
    )
};
export default SocialMediaPost;